import { createSvgComponent } from "../../icon/createSvgComponent";
import Manual from "@core/__generated__/icon/figma/manual.svg";
export default createSvgComponent(Manual);